import React from "react";
import style from "./style.module.css";

export const Pointer = () => <div className={style.pointer} />;

export default Pointer;
